import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.to-string.js";
import store from '@/store';
import axios from 'axios';
import { get } from 'lodash';
import { Message, Notification } from 'element-ui';
import utils from '@/utils';
import env from '@/env';
import i18n from '@/i18n'; // 记录和显示错误

function log(error) {
  store.dispatch('d2admin/log/push', {
    message: 'Data request exception',
    type: 'danger',
    meta: {
      error: error
    }
  });

  if (env.NODE_ENV === 'development') {
    utils.log.danger('>>>>>> Error >>>>>>'); // localStorage.clear();
    // delCookie();
    // console.error(error)
    // Notification.error({
    //   title: 'Authentication failed',
    //   message: 'please login again'
    // })
    // store.dispatch('d2admin/user/logout', { focus: true, remote: false, back: true })
  }

  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
}

var service = axios.create();

function delCookie() {
  var keys = document.cookie.match(/[^ =;]+(?==)/g);

  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.ratingdog.cn

      document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.ratingdog.cn

      document.cookie = keys[i] + '=0;path=/;domain=bestwond.com;expires=' + new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .ratingdog.cn
    }
  }
}

service.interceptors.response.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
    var dataAxios, error;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dataAxios = response.data;

            if (!(dataAxios.code === 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", dataAxios.data);

          case 5:
            error = new Error(dataAxios.msg); // 需要重新登录
            // 50008 - 无效的 token
            // 50012 - 其它客户端登录
            // 50014 - token 过期

            if (!([50008, 50012, 50014].indexOf(dataAxios.code) >= 0)) {
              _context.next = 12;
              break;
            }

            Notification.error({
              title: 'Authentication failed',
              message: 'please login again'
            });
            _context.next = 10;
            return store.dispatch('d2admin/user/logout', {
              focus: true,
              remote: false,
              back: true
            });

          case 10:
            _context.next = 13;
            break;

          case 12:
            log(error);

          case 13:
            return _context.abrupt("return", Promise.reject(error));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = 'Request error';
        break;

      case 401:
        error.message = 'Unauthorized, please log in';
        break;

      case 403:
        error.message = 'access denied';
        break;

      case 404:
        error.message = "Request address error: ".concat(error.response.config.url);
        break;

      case 408:
        error.message = 'Request timed out';
        break;

      case 500:
        error.message = 'Server internal error';
        break;

      case 501:
        error.message = 'Service not implemented';
        break;

      case 502:
        error.message = 'Gateway error';
        break;

      case 503:
        error.message = 'service is not available';
        break;

      case 504:
        error.message = 'Gateway timeout';
        break;

      case 505:
        error.message = 'HTTP version is not supported';
        break;

      default:
        break;
    }
  }

  log(error);
  console.log('-------------error.response.status==', error.response.status);

  if (error.response.status == 401 || error.response.status == 504) {
    localStorage.clear();
    delCookie();
    alert('请重新登录');
  }

  return Promise.reject(error);
});
export function request(config) {
  var token = utils.cookies.get('token');
  var configDefault = {
    headers: {
      'locale': i18n.locale,
      'Authorization': token,
      'Content-Type': get(config, 'headers.Content-Type', 'application/json')
    },
    // timeout: 8000,
    baseURL: store.state.d2admin.api.base,
    data: {}
  };
  return service(Object.assign(configDefault, config));
}